import { useEffect, useRef } from 'react';

export const useDebouncedCallback = <A extends any[]>(callback: (...args: A) => void, waitTimeout: number) => {
    const argsRef = useRef<A>();
    const timeout = useRef<ReturnType<typeof setTimeout>>();
    const cleanup = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
    };
    useEffect(() => cleanup, []);
    return (...args: A) => {
        argsRef.current = args;
        cleanup();
        timeout.current = setTimeout(() => {
            if (argsRef.current) {
                callback(...argsRef.current);
            }
        }, waitTimeout);
    };
};
